(() => {
    'use strict';

    howspace.widgets.onEvent('fileshare:files:added', (widget, notification) => {
        // Wait for the modal close animation to finish before adding the new files.
        const modalAnimDuration = howspace.getAnimationDuration(widget, '--modal-animation-duration');
        setTimeout(() => {
            addFilesToWidget(widget, notification.object.files);
        }, modalAnimDuration);
    });

    const addFilesToWidget = (widget, files) => {
        const widgetId = widget.data('widget-id');
        const icons = $(howspace.template.getElement(widget.find('template.file-icons-template')));
        const sortableList = widget.find('.howspace-sortable-list');

        if (sortableList.length > 0) {
            files.forEach(file => {
                const fileObject = $.extend({}, file, {
                    icon : icons.find('.icon.' + file.icon)[0]?.outerHTML ?? '',
                    url : `${real.baseUri}/widget/fileshare/${widgetId}/inline/${file.id}/download`
                });
                howspace.components.sortableList.addItem(sortableList, fileObject);
            });
        } else {
            howspace.components.lister.reload(widget.find('.howspace-lister'));
        }
    };

    const initFileUploaderModal = (modal, modalOpener) => {
        modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
            handleFileUploadCompleted(modal, modalOpener, e.detail.uploadedFiles);
        });
    };

    const handleFileUploadCompleted = (modal, modalOpener, uploadedFiles) => {
        const widget = $(modalOpener.closest('.widget-fileshare'));
        if (widget.length === 0) {
            // No fileshare widget found from the DOM.
            return;
        }

        if (widget.data('widget-mode') === 'view') {
            const dataPayload = {
                files: ['*']
            };

            // Add the uploaded files to the data payload.
            uploadedFiles.forEach(uploadedFile => {
                dataPayload.files.push(uploadedFile.id);
            });

            real.ajax.json(howspace.widgets.getApiUrl(widget), {
                type : 'POST',
                data : JSON.stringify(dataPayload)
            });
        } else {
            // Wait for the modal close animation to finish before adding the new files.
            const modalAnimDuration = howspace.getAnimationDuration(modal, '--modal-animation-duration');
            setTimeout(() => {
                addFilesToWidget(widget, uploadedFiles);
            }, modalAnimDuration);
        }

        howspace.components.modal.close(modal);
    };

    howspace.widgets.fileshare = {
        initView: widget => {
            // Empty for now.
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Empty for now.
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        initFileUploaderModal : initFileUploaderModal
    };
})();
